import React, { useState, useContext, useEffect, useRef } from "react";
import styled, { keyframes, css } from "styled-components";
import ReactHtmlParser from "react-html-parser";
import { isEmpty } from "lodash";

import { Link } from "react-router-dom";

import { useAmazonContext } from "../../Contexts/AmazonContext";
import "../sidebar/Sidebar.css";
import "../Lesson.css";
import ConfettiExplosion from "react-confetti-explosion";
import { motion } from "framer-motion";

import axios from "axios";

const ExampleBox = styled.div`
  /* box-shadow: 0 0.1rem 0.5rem rgba(0, 0, 0, 0.2); */
  border-radius: 5px;
  padding: 10px;
  /* background: #252525; */
  /* margin-top: 80px; */
  font-family: "Quicksand", sans-serif;
`;

const ExampleQuestion = styled.div`
  /* font-size: 17px; */
  font-size: 2.5vh;
  font-weight: bold;
  text-align: center;
  color: #a678de;
  padding: 20px;
`;

const ExampleAnswer = styled(motion.div)`
  font-size: 2.5vh;
  font-weight: bold;
  text-align: center;
  font-family: Quicksand;
  /* border-radius: 15px; */
  /* padding: 10px; */
  color: #252525;
  display: flex;
  background: ${(props) =>
    props.answerClicked == props.answer ? props.answerColor : "#D2CFE6"};
  /* margin: 20px; */
  transition: transform 300ms;
  justify-content: center;

  &:hover {
    cursor: pointer;
  }
`;

const AnswerExplanation = styled.div`
  /* font-size: 2vh; */
  display: ${(props) =>
    props.answerClicked == props.answer ? "flex" : "none"};
  align-items: center;
  justify-content: center;
`;

const LessonExamplePreview = (props) => {
  console.log(props);
  //Obtain Example Data from back end
  const { courseTitleUserIsOn, entryStore, isDarkMode } = useAmazonContext();
  const themeDark = typeof props.previewDark === "boolean" ? props.previewDark : isDarkMode;

  console.log(entryStore);

  const [answerColor, setAnswerColor] = useState("#e8e2ef");
  const [answerClicked, setAnswerClicked] = useState("NoAnswer");
  const [answerClickedToPractice, setAnswerClickedToPractice] = useState(false);
  const [progressPosted, setProgressPosted] = useState(false);
  const [progressData, setProgressData] = useState(null); //Put it as state to ensure new data after fetch is sent to chapterProgressBar

  const nextLessonBoxRef = useRef(null);

  // State to hold the shuffled answers
  const [answeredCorrectly, setAnsweredCorrectly] = useState(false);
  const [selectedExample, setSelectedExample] = useState({});
  const [shuffledAnswers, setShuffledAnswers] = useState([]);
  const isMobile = window.innerWidth <= 768; // You can adjust the breakpoint (768) as needed

  // Randomiser function to choose an example for this Lesson

  const chooseRandomExample = (sectionNumber) => {
    let allSectionExamples =
      props.exampleDatafromBackEnd.length !== 0 &&
      props.exampleDatafromBackEnd.filter(
        //list of ALL examples for a particular section in the database
        (example) => example.sectionNumber == sectionNumber
      );
    const random = Math.floor(Math.random() * allSectionExamples.length);
    let selectedExample = allSectionExamples[random];
    return selectedExample;
  };

  const checkAnswer = async (isCorrect, answer) => {
    setAnswerClicked(answer);
    setAnswerClickedToPractice(true);

    if (isCorrect === true && !progressPosted) {
      setAnswerColor("#DAF7A6");
      setAnsweredCorrectly(true);
      // Trigger confetti burst
      // Scroll distance based on device type
      const scrollDistance = isMobile ? 20 : 20;
      // Scroll smoothly by 600 pixels after 300ms after answer is correct
      setTimeout(() => {
        window.scrollBy({
          top: scrollDistance,
          behavior: "smooth",
        });
      }, 300);
    } else {
      setAnswerColor("#ff726f");
    }
  };

  // Utility function to shuffle an array
  function shuffleArray(array) {
    const shuffledArray = [...array];
    for (let i = shuffledArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledArray[i], shuffledArray[j]] = [
        shuffledArray[j],
        shuffledArray[i],
      ];
    }
    return shuffledArray;
  }
  useEffect(() => {
    const randomIndex = Math.floor(
      Math.random() * props.exampleDatafromBackEnd.length
    );

    var selectedExampleOne = props.exampleDatafromBackEnd[randomIndex];
    setSelectedExample(selectedExampleOne);

    // Check if selectedExampleOne is not an empty object using Lodash
    if (!isEmpty(selectedExampleOne)) {
      setShuffledAnswers(shuffleArray(selectedExampleOne.answers));
    }
  }, [props.lessonNumber, props.exampleDatafromBackEnd.length]);

  console.log(selectedExample);
  console.log(props.lessonNumber);
  console.log(props.exampleDatafromBackEnd);

  return (
    <ExampleBox className="LessonExampleBox">
      <ExampleQuestion>
        {ReactHtmlParser(selectedExample && selectedExample.question)}
      </ExampleQuestion>
      {shuffledAnswers.map((answerItem) => {
        return (
          <>
            <ExampleAnswer
              className="LessonExampleAnswerBox"
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.8 }}
              transition={{ type: "spring", stiffness: 400, damping: 17 }}
              onClick={() =>
                checkAnswer(answerItem.isCorrect, answerItem.answer)
              }
              answerColor={answerColor}
              answer={answerItem.answer}
              answerClicked={answerClicked}
            >
              <div className="LessonExampleAnswer">
                {ReactHtmlParser(answerItem.answer)}
              </div>
            </ExampleAnswer>
            {
              <AnswerExplanation
                answerClicked={answerClicked}
                answer={answerItem.answer}
                answerColor={answerColor}
              >
                {answerItem.isCorrect == false ? (
                  <div
                    className={`LessonExampleAnswerExplanationContainer ${
                      themeDark ? "darkThemeFont" : "lightThemeFont"
                    }`}
                  >
                    <i class="wrongCross fa-solid fa-xmark"></i>
                    <p
                      style={{
                        display: "inline",
                      }}
                      className="LessonExampleAnswerExplanation"
                    >
                      {ReactHtmlParser(answerItem.explanation)}
                    </p>
                  </div>
                ) : (
                  <>
                    <i class="correctCheckMark fa-solid fa-check"></i>
                    {answeredCorrectly && (
                      <ConfettiExplosion
                        autoStart={true}
                        duration={5000}
                        particleCount={100}
                        spread={360}
                        origin={{ x: 0.8, y: 0.5 }}
                        force={0.8}
                        width={1600}
                      />
                    )}
                    <p
                      className={`LessonExampleAnswerExplanation ${
                        themeDark ? "darkThemeFont" : "lightThemeFont"
                      }`}
                    >
                      Correct!
                    </p>
                    {answeredCorrectly && (
                      <ConfettiExplosion
                        autoStart={true}
                        duration={5000}
                        particleCount={100}
                        spread={360}
                        origin={{ x: 0.8, y: 0.5 }}
                        force={0.8}
                        width={1600}
                      />
                    )}
                  </>
                )}
              </AnswerExplanation>
            }
          </>
        );
      })}
      {/* Render the "Next Lesson" button if answered correctly */}
    </ExampleBox>
  );
};

export default LessonExamplePreview;
